import React from "react";
import { Layout as LayoutReactAdmin, LayoutProps as CoreLayoutProps } from "react-admin";

// Components
import AppBar from "../AppBar";

const Layout = (props: CoreLayoutProps) => <LayoutReactAdmin appBar={AppBar} {...props} />;

export default Layout;
